import React, { createContext, useContext, useEffect, useState } from "react";
import { adminLogin, adminMe } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("freeayto_admin_token");
    const stored = localStorage.getItem("freeayto_admin_user");
    if (token && stored) {
      try {
        setUser(JSON.parse(stored));
      } catch {
        setUser(null);
      }
      // Optional re-validate
      adminMe()
        .then((u) => setUser({ username: u.username }))
        .catch(() => {
          setUser(null);
          localStorage.removeItem("freeayto_admin_token");
          localStorage.removeItem("freeayto_admin_user");
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    const res = await adminLogin(username, password);
    localStorage.setItem("freeayto_admin_token", res.access_token);
    const u = { username: res.username };
    localStorage.setItem("freeayto_admin_user", JSON.stringify(u));
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem("freeayto_admin_token");
    localStorage.removeItem("freeayto_admin_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
